export function StoreTenantInformation(payload){
  return {
    type: "StoreTenantInformation",
    payload: payload,
  };
}
export function UpdateTenantCoverage(payload){
  return {
    type: "UpdateTenantCoverage",
    payload: payload,
  };
}
export function UpdateTenantLogoLoginSession(payload){
  return {
    type: "UpdateTenantLogoLoginSession",
    payload: payload,
  };
}
export function UpdateTenantLogoDashboardSession(payload){
  return {
    type: "UpdateTenantLogoDashboardSession",
    payload: payload,
  };
}
export function UpdateTenantLogoReportSession(payload){
  return {
    type: "UpdateTenantLogoReportSession",
    payload: payload,
  };
}
export function UpdateAllTenantSession(payload){
  return {
    type: "UpdateAllTenantSession",
    payload: payload,
  };
}



// WEBPACK FOOTER //
// ./src/App/store/tenant/action.js